const article = {
  slug: 'invoices',
  title: 'Invoices - sweeps, void, due dates',
  section: 'Money',
  body: `
# Invoices

## Where invoices come from

Rent invoices are minted by the **monthly sweep** on your facility's
invoice generation day (Settings -> Facility), a few days before the due
date - not at move-in. Fees (late, NSF) mint their own invoice lines
when they fire.

## Void / unvoid

Open the invoice row menu:

- **Void** removes the invoice from the tenant's balance (mistake,
  goodwill). Paid invoices can't be voided - refund the payment first.
- **Unvoid** restores it.

Bulk-select supports sending and voiding multiple invoices at once.

## Reading statuses

- **sent** - issued, unpaid.
- **paid** - fully covered; payments apply oldest-first.
- **overdue** - past due date; the late-fee tiers you configured in
  Settings -> Fees take it from here.
- **void** - removed from the ledger.

> If a tenant "paid but still shows a balance," check whether the
> payment was recorded **without selecting the rental** - unlinked
> payments don't reduce invoices.
`,
};

export default article;
